import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../admin/AdminLogin.css";
import  { API_BASE_URL } from '../config';

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_BASE_URL}/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
  alert("✅ Login Successful!");

  // Save user + token together
  localStorage.setItem("adminInfo", JSON.stringify({
    user: data.admin,
    token: data.token,
  }));

  navigate("/admin/dashboard");
} else {
        setError(data.message || "❌ Invalid credentials!");
      }
    } catch (err) {
      console.error(err);
      setError("⚠️ Server error. Please try again later.");
    }
  };

  return (
    <div className="admin-login-container">
      {/* 🔹 HEADER SECTION */}
     <header className="admin-login-header">
  <div className="header-left">
    <img src="/logo.png" alt="FlyTutor Logo" className="admin-logo" />
  </div>

  <div className="header-center">
    <h1>My Application</h1>
  </div>

  <div className="header-right">
    <a href="/" className="navbar-link">Home</a>
  </div>
</header>


      {/* 🔹 LOGIN CARD */}
      <div className="admin-login-card">
        <h2 className="admin-login-title">ADMIN LOGIN</h2>

        <form className="admin-login-form" onSubmit={handleSubmit}>
          <label>Mail id</label>
          <input
            type="email"
            placeholder="Enter your Mail id"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Password</label>
          <input
            type="password"
            placeholder="Enter your Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && <p className="error-msg">{error}</p>}

          <button type="submit" className="admin-login-btn">
            LOGIN
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
